<template>
    <div>
        {{ display }}
    </div>
</template>

<script>
import { format } from "@/formatting/currencyFormatter";

export default {
    types: [
        "currency"
    ],
    props: {
        value: {
            type: [ Number ],
            default: null,
        }
    },
    computed: {
        display() {
            return format(this.value);
        }
    }
};
</script>
